import { type SerializedCompStructure } from '@wix/document-services-types'

import { type AddressInputData } from '../types'

export function assertAddressInputData(
  data: NonNullable<SerializedCompStructure['data']>,
): asserts data is AddressInputData {
  const TYPE: AddressInputData['type'] = 'AddressInput'
  if (data.type !== TYPE) {
    throw new Error('Not address-input data.')
  }
}
